import type { Developer } from "../types";
import { DeveloperEdit } from "./DeveloperEdit";
import { DeveloperList } from "./DeveloperList";
import { DeveloperShow } from "./DeveloperShow";

/**
 * ASSUMPTIONS (Almikia Epic E1 backlog):
 * - No create page: the 4 developers are seeded (TASK-001) and a new one
 *   only makes sense with a new project, whose codes are constrained.
 * - No delete action: catalogue records are never hard-deleted, enforced
 *   both in the UI (canAccess.ts) and at the database level (TASK-001).
 */
export default {
  list: DeveloperList,
  show: DeveloperShow,
  edit: DeveloperEdit,
  recordRepresentation: (record: Developer) => record.legal_name,
};
